import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { MsalProvider } from "@azure/msal-react";
import { msal } from "./auth/msal";
import { ConfirmProvider } from "./components/Confirm";
import App from "./App";
import "./index.css";

msal.initialize().then(() => {
  msal.handleRedirectPromise().then(() => {
    const accounts = msal.getAllAccounts();
    if (accounts.length > 0) msal.setActiveAccount(accounts[0]);
    const qc = new QueryClient({ defaultOptions: { queries: { retry: 1, staleTime: 30000 } } });
    ReactDOM.createRoot(document.getElementById("root")!).render(
      <React.StrictMode>
        <MsalProvider instance={msal}>
          <QueryClientProvider client={qc}>
            <BrowserRouter>
              <ConfirmProvider>
                <App />
              </ConfirmProvider>
            </BrowserRouter>
          </QueryClientProvider>
        </MsalProvider>
      </React.StrictMode>
    );
  });
});
